export default __webpack_public_path__ + "static/media/mayowa_shopper.0b4b04dc.jpg";